const resetStateToIndex = (store) => {
  store.dispatch('canvasResetState');
  store.dispatch('boxResetActive');
  store.dispatch('jumpResetActive');
  store.dispatch('optionResetActive');
  store.dispatch('reportResetState');
  store.dispatch('stepResetState');
  store.dispatch('sidebarResetState');
  store.dispatch('quizResetState');
  store.dispatch('themeResetState');
};

export const setup = (router, store) => {
  router.beforeEach((to, from, next) => {
    if (to.name === 'index') {
      resetStateToIndex(store);
    }
    next();
  });
};



/** WEBPACK FOOTER **
 ** ./src/router/watcher.js
 **/